import { useState } from 'react';
import { OjoIcono } from './OjoIcono';

/**
 * Un campo de contraseña con el ojo para verla mientras se escribe.
 *
 * Existe como componente y no suelto en cada pantalla porque los campos de
 * contraseña del panel son nueve, repartidos en cinco archivos: acceso,
 * cambiar, restablecer, invitación y segundo factor. Puesto a mano, el que se
 * olvida no da ningún error — simplemente no tiene el ojo, y se descubre
 * cuando alguien se pelea con una clave larga que no puede revisar.
 *
 * El estado arranca oculto siempre y no se recuerda entre montajes: que una
 * pantalla de credenciales abra mostrando lo que se escribió antes es
 * exactamente lo que nadie espera.
 */
export function CampoContrasena({
  etiqueta,
  valor,
  onCambio,
  autoComplete,
  autoFocus,
  requerido = true,
}: {
  etiqueta: string;
  valor: string;
  onCambio: (valor: string) => void;
  autoComplete: string;
  autoFocus?: boolean;
  requerido?: boolean;
}) {
  const [visible, setVisible] = useState(false);
  const accion = visible ? 'Esconder la contraseña' : 'Mostrar la contraseña';

  return (
    <label>
      <span>{etiqueta}</span>
      <div className="campo-contrasena">
        <input
          type={visible ? 'text' : 'password'}
          value={valor}
          onChange={(e) => onCambio(e.target.value)}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          required={requerido}
        />
        {/*
          `type="button"` y no el que viene por defecto: dentro de un
          formulario, un botón sin tipo envía. Sin esto, mirar la contraseña
          intentaría entrar con lo que hubiera escrito hasta ese momento.
        */}
        <button
          type="button"
          className="icono-ojo"
          onClick={() => setVisible(!visible)}
          aria-label={accion}
          aria-pressed={visible}
          title={accion}
        >
          <OjoIcono abierto={visible} />
        </button>
      </div>
    </label>
  );
}
